import script from "./ViewImageModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewImageModal.vue?vue&type=script&setup=true&lang=js"

import "./ViewImageModal.vue?vue&type=style&index=0&id=1a0467d0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a0467d0"]])

export default __exports__